import styled from 'styled-components';

const ResponsivePlayer = styled.div`
  position: relative;
  padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */

  width: ${props => (props.fullSize ? '100%' : '')};
  height: ${props => (props.fullSize ? '100%' : '')};

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export default {
  ResponsivePlayer
};
